import React, { useState, useEffect } from 'react';
import Header from './gapsy-header';
import Navigation from './gapsy-Anavigation';
import Footer from './gapsy-footer';
import "bootstrap/dist/css/bootstrap.min.css"
import 'bootstrap-icons/font/bootstrap-icons.css';
import styles from '../assets/css/gapsy-dashboard.module.css';
import tabStyles from '../assets/css/gapsy-tabs.module.css';
import { List_Checker, createTextFileApi, mappingdata, RoleandMapping, OwnershipApi, ListAlldept, Getlocations } from "../components/ApiProperty";
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import formStyles from '../assets/css/gapsy-form.module.css';
import { BiSortUp, BiSortDown, BiSort } from "react-icons/bi";
import tableStyles from '../assets/css/sharedTableStyles.module.css';
import { tableCellStyle2, UsersPagination } from "../components/TableProperty";
import { Modal, Button } from 'react-bootstrap';
import { SearchBox, UploadLoadingIcon } from "../components/Propertyfile";

const GapsyUserRoleandMapping = () => {
    const [activeTab, setActiveTab] = useState('ldap'); // 'manual' or 'ai'
    const [users, setUsers] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [filteredUsers, setFilteredUsers] = useState([]);
    const usersItemsPerPage = 7; // Set the number of items per page
    const navigate = useNavigate();
    const [userPerPage, setUsersPerPage] = useState(1); // Set the initial page to 1
    const [showModalLdap, setShowModalLdap] = useState(false);
    const [editIndex, setEditIndex] = useState(null);
    const [checkerData, setCheckerData] = useState(null);
    const [message, setMessage] = useState("");
    const [modalMessage, setModalMessage] = useState('');
    const [messageType, setMessageType] = useState(''); // 'success', 'warning', or 'error'
    const [selectedDepartments, setSelectedDepartments] = useState([]);
    const [modalMessage3, setModalMessage3] = useState('');
    const [pendingPayload, setPendingPayload] = useState(null); // store request for retry

    const [selectedOption, setSelectedOption] = useState('All');
    const [disableInputs, setDisableInputs] = useState(false);
    const [passwordGenerated, setPasswordGenerated] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [selectedLocationValues, setSelectedLocationValues] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [showAllowUploadPopup, setShowAllowUploadPopup] = useState(false);
    const [showNoRecordsModal, setShowNoRecordsModal] = useState(false);
    const [mode, setMode] = useState("");
    const [departments, setDepartments] = useState([]); // Initialize as empty array
    const [formData, setFormData] = useState({
        adminId: '',
        userId: '',
        userName: '',
        userRole: '',
        departments: '',
        departmentname: '',
        userRole: '',
        orgHierarchy: '',
        userLocation: '',
        active_yn: '',
        mappedId: '',
        searchUserId: '' // Add this line
    });
    const [initialData, setInitialData] = useState({});
    const [selectedRole, setSelectedRole] = useState('');
    const [hierarchy, setHierarchy] = useState('');
    const [sortConfig, setSortConfig] = useState({ key: 'userId', direction: 'asc' });
    const [error, setError] = useState("");
    const [selectedStatus, setSelectedStatus] = useState('');
    const [selectedChecker, setSelectedChecker] = useState('');

    let csrfToken = sessionStorage.getItem("tokenizedSession");



    const dept = sessionStorage.getItem("dept");

    const roles = [
        "CRO",
        "Risk Officer",
        "Department Head"
    ];

    useEffect(() => {
        fetchUsers();
    }, []);

    // useEffect(() => {
    //     const fetchUsers = async () => {
    //         try {
    //             setIsLoading(true);
    //             const config = {
    //                 params: { "adminId": localStorage.getItem('userid'), tableName: "user_role_mapping" },
    //                 headers: {
    //                     'x-csrf-token': csrfToken,
    //                 },
    //                 withCredentials: true
    //             }
    //             const response = await axios.post(RoleandMapping, {}, config);

    //             const apiData = (response.data.data || []).map(item => ({
    //                 userId: item.USERID,
    //                 userName: item.USERNAME,
    //                 userRole: item.USERROLE,
    //                 departmentname: item.DEPARTMENT_NAME,
    //                 active_yn: 'Y' // default if not present
    //             }));
    //             console.log("Fetched Users Data:", apiData);

    //             setUsers(apiData);
    //             setFilteredUsers(apiData);
    //             setIsLoading(false);
    //         } catch (error) {
    //             console.error('There was an error fetching the users!', error);
    //             setIsLoading(false);
    //         }
    //     };
    //     fetchUsers();
    // }, []);

    const fetchUsers = async () => {
        try {
            // setIsLoading(true);

            const config = {
                params: {
                    adminId: localStorage.getItem('userid'),
                    tableName: "user_role_mapping"
                },
                headers: {
                    'x-csrf-token': csrfToken,
                },
                withCredentials: true
            };

            const response = await axios.post(RoleandMapping, {}, config);

            const apiData = (response.data.data || []).map(item => ({
                userId: item.USERID,
                userName: item.USERNAME,
                userRole: item.USERROLE,
                departmentname: item.DEPARTMENT_NAME,
                active_yn: 'Y'
            }));

            setUsers(apiData);
            setFilteredUsers(apiData);

        } catch (error) {
            console.error('Error fetching users!', error);
        } finally {
            setIsLoading(false);
        }
    };

    const fetchOwnership = async () => {
        try {
            // setIsLoading(true);
            const config = {
                params: { "adminId": localStorage.getItem('userid'), ownership: "Y" },
                headers: {
                    'x-csrf-token': csrfToken,
                },
                withCredentials: true
            }
            const response = await axios.post(OwnershipApi, {}, config);
            console.log("Ownership API Response:", response.data);

            // Extract Ownership array
            const ownershipList = response.data?.Ownership || [];
            console.log("Fetched Ownership List:", ownershipList);

            setDepartments(ownershipList);

        } catch (error) {
            console.error("Error fetching departments:", error);
            setDepartments([]);
        }
    };

    useEffect(() => {
        fetchOwnership();
    }, []);

    const handleCancelUpload = () => {
        setShowAllowUploadPopup(false);
        setPendingPayload(null);
    };

    // useEffect(() => {
    //     const fetchDepartments = async () => {
    //         const sessionDept = sessionStorage.getItem("dept");

    //         try {
    //             // Fetch all departments for everyone
    //             const deptConfig = {
    //                 headers: {
    //                     userId: localStorage.getItem('userid'),
    //                     'x-csrf-token': csrfToken,
    //                 },
    //                 withCredentials: true
    //             };

    //             const response = await axios.post(ListAlldept, {}, deptConfig);

    //             if (response.data?.department && Array.isArray(response.data.department)) {
    //                 const allDepartments = response.data.department.map((name, index) => ({
    //                     id: index + 1,
    //                     name
    //                 }));

    //                 if (sessionDept === "IT") {
    //                     // IT users see all departments
    //                     setDepartments(allDepartments);
    //                 } else {
    //                     // Non-IT users see all departments but their own department is selected by default
    //                     setDepartments(allDepartments);

    //                     // Set their department as the initial value in the form
    //                     setFormData(prev => ({
    //                         ...prev,
    //                         orgHierarchy: sessionDept
    //                     }));
    //                 }
    //             } else {
    //                 // Fallback to just their department if API fails
    //                 setDepartments([{ id: 1, name: sessionDept }]);
    //                 setFormData(prev => ({
    //                     ...prev,
    //                     orgHierarchy: sessionDept
    //                 }));
    //             }
    //         } catch (error) {
    //             console.error('Error fetching departments:', error);
    //             // Fallback to just their department if API fails
    //             setDepartments([{ id: 1, name: sessionDept }]);
    //             setFormData(prev => ({
    //                 ...prev,
    //                 orgHierarchy: sessionDept
    //             }));
    //         }
    //     };

    //     fetchDepartments();
    // }, []);


    const handleShow = (isEdit = false, mode) => {
        if (!isEdit) {
            setFormData({ adminId: '', userId: '', userFirstName: '', userLastName: '', userEmail: '', userPassword: '', userRole: '', orgHierarchy: '', userLocation: '', active_yn: '', mappedId: '' });
            setInitialData(users);
            setEditIndex(isEdit);
        }
        setError(null);
        setMode(mode);
        setShowModal(true);
    };

    const handleForceUpload = async () => {
        try {
            setShowAllowUploadPopup(false);
            // setIsLoading(true);

            const responseDb = await submitLdapData('Y'); // second call

            if (responseDb.data?.status === 'success') {
                setMessageType('success');
                setModalMessage(responseDb.data?.message);
            } else {
                setMessageType('error');
                setModalMessage(responseDb.data?.message || "Update failed");
            }

        } catch (error) {
            console.error(error);
            setMessageType('error');
            setModalMessage('Error while updating');
        } finally {
            setIsLoading(false);
            setPendingPayload(null);
        }
    };

    const submitLdapData = async (allowUpdate = '') => {
        const adminId = localStorage.getItem('userid') || '';

        const jsonData = {
            userId: formData.userId,
            userName: formData.userName,
            role: selectedRole,
            departments: selectedDepartments,
            adminId: adminId
        };

        const content = JSON.stringify(jsonData, null, 2);
        const filename = `${adminId}_config.json`;

        // Step 1: Save file
        await axios.post(
            createTextFileApi,
            { filename, content },
            {
                headers: {
                    'Content-Type': 'application/json',
                    userId: adminId,
                    'x-csrf-token': csrfToken,
                },
                withCredentials: true,
            }
        );

        // Step 2: Call API
        const config = {
            headers: {
                userId: adminId,
                "x-csrf-token": csrfToken
            },
            withCredentials: true,
            params: {
                filePath: `/saswork/nas/${filename}`,
                Notifications: "IN",
                dept: dept,
                allowUpdate: allowUpdate   // 🔥 dynamic
            }
        };

        return await axios.post(mappingdata, {}, config);
    };

    const handleLdapSubmit = async (e) => {
        e.preventDefault();

        try {
            const adminId = localStorage.getItem('userid') || '';

            // Validation

            if (!selectedRole) {
                setMessageType('error');
                setModalMessage("Role is required");
                return;
            }

            if (selectedDepartments.length === 0) {
                setMessageType('error');
                setModalMessage("Department is required");
                return;
            }

            // setIsLoading(true);

            const responseDb = await submitLdapData(); // first call

            if (responseDb.data?.status?.toLowerCase() === 'update') {

                // store state for retry
                setPendingPayload(true);

                setModalMessage3(`
                  ${formData.userId} is already mapped to ${responseDb.data.userRole} role.<br/>
                  Existing Department: ${responseDb.data.existingDepartment}<br/>
                  Do you want to update?
              `);

                setShowAllowUploadPopup(true);
                return;
            }

            if (responseDb.data?.status === 'success') {
                setMessageType('success');
                setModalMessage(responseDb.data?.message);
            } else {
                setMessageType('error');
                setModalMessage(responseDb.data?.message || "Failed");
            }

        } catch (error) {
            console.error(error);
            setMessageType('error');
            setModalMessage('Error while processing request');
        } finally {
            setIsLoading(false);
        }
    };


    // const handleCloseLdap = () => {

    //     if (messageType === 'error') {
    //         setModalMessage('');
    //         return;
    //     }
    //     setShowModalLdap(false);

    //     setFormData({
    //         searchUserId: "",
    //         userFirstName: "",
    //         userRole: "",
    //         orgHierarchy: ""
    //     });

    //     setModalMessage('');
    //     setSelectedRole("");           //  FIX
    //     setSelectedDepartments([]);    //  FIX

    //     setInitialData({});
    //     setEditIndex(null);
    //     setMessage('');
    // };
    const handleCloseModal = () => {
        setModalMessage('');
        setMessageType('');
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };


    const handleRoleChange = (e) => {
        const newRole = e.target.value;

        // Clear mappedId if changing from Checker to Maker
        if (selectedRole === 'Checker' && newRole === 'Maker') {
            localStorage.removeItem('mappedId');
        }

        setFormData({
            ...formData,
            userRole: newRole,
        });
        setSelectedRole(newRole);
    };

    // const handleCloseLdap = () => {
    //     setModalMessage('');
    //     setModalMessage3('');
    //     setShowModalLdap(false);
    //     // setFormData({ userName: '', userId: '', userRole: '', departmentname: '', departments: '', userPassword: '', userRole: '', orgHierarchy: '', userLocation: '', active_yn: '', mappedId: '' });
    //     setInitialData({});
    //     setEditIndex(null);
    //     setMessage('');
    // };

    const handleCloseLdap = () => {
        setModalMessage('');
        setModalMessage3('');
        setShowModalLdap(false);

        setInitialData({});
        setEditIndex(null);
        setMessage('');

        // ✅ REFRESH TABLE
        fetchUsers();
    };

    const handleFocus = (e) => {
        const { name } = e.target;
        if (!validateField(name)) {
            e.preventDefault();
        }
    };
    // const handleHierarchyChange = async (hierarchyValue) => {
    //     // Update form state
    //     setFormData((prevFormData) => ({
    //         ...prevFormData,
    //         orgHierarchy: hierarchyValue,
    //     }));

    //     // Update hierarchy state
    //     setHierarchy(hierarchyValue);

    //     try {
    //         // 1. First API call - Fetch locations
    //         const locationResponse = await fetch(Getlocations, {
    //             method: 'POST',
    //             headers: {
    //                 'x-csrf-token': csrfToken // if needed
    //             },
    //         });
    //         if (!locationResponse.ok) {
    //             throw new Error('Failed to fetch location data');
    //         }

    //         const locationData = await locationResponse.json();
    //         // setSelectedLocationValues(locationData.location || []);
    //         setSelectedLocationValues(Array.isArray(locationData.location) ? locationData.location : []);

    //         // 2. Second API call - Fetch list of checkers (only if hierarchyValue means which we selected in dropdown)
    //         if (hierarchyValue) {
    //             const config = {
    //                 params: {
    //                     "adminId": localStorage.getItem('userid'),
    //                     "dept": hierarchyValue
    //                 },
    //                 headers: {
    //                     'x-csrf-token': csrfToken,
    //                 },
    //                 withCredentials: true
    //             };
    //             const checkersResponse = await axios.post(List_Checker, {}, config);
    //             setCheckerData(checkersResponse.data.checkers_list);

    //         }
    //     } catch (error) {
    //         console.error('Error in handleHierarchyChange:', error.message);
    //         setSelectedLocationValues([]);
    //         setCheckerData([]); // Reset checkers data on error
    //     }
    // };

    const handleCheckers = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
        setSelectedChecker(e.target.value);
    };

    const handleUserStatus = (e) => {
        setFormData({
            ...formData,
            active_yn: e.target.value,
        });
        setSelectedStatus(e.target.value);
    };

    const validateField = (fieldName) => {
        if (fieldName === 'userFirstName' && !formData.userId) {
            setError('User Id is required');
            return false;
        }
        if (fieldName === 'userEmail' && !formData.userId) {
            setError('User Name is required');
            return false;
        }
        if (fieldName === 'userPassword' && !formData.userId) {
            setError('User Password is required');
            return false;
        }
        // Clear error message if validation passes
        setError(null);
        return true;
    };

    const handleDashboard = (e) => {
        e.preventDefault();
        navigate('/gapsyAdashboard');
        // Additional logic if needed
    };

    const handleAddRow = (e) => {
        e.preventDefault();
        navigate('/gapsyusermapping');
        // Additional logic if needed
    };

    const validateEmail = (inputEmail) => {
        // Regular expression for basic email format validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(inputEmail);
    };

    const getSortedAndFilteredUsers = () => {
        if (!Array.isArray(filteredUsers)) return [];  // ✅ safety

        return [...filteredUsers].sort((a, b) => {
            if (a.newlyCreated && !b.newlyCreated) return -1;
            if (!a.newlyCreated && b.newlyCreated) return 1;

            const aValue = typeof a[sortConfig.key] === 'string'
                ? a[sortConfig.key].toLowerCase()
                : a[sortConfig.key];

            const bValue = typeof b[sortConfig.key] === 'string'
                ? b[sortConfig.key].toLowerCase()
                : b[sortConfig.key];

            if (aValue < bValue) return sortConfig.direction === 'asc' ? -1 : 1;
            if (aValue > bValue) return sortConfig.direction === 'asc' ? 1 : -1;

            return 0;
        });
    };

    const sortedAndFilteredUsers = getSortedAndFilteredUsers();


    const handleReset = () => {
        if (!initialData || Object.keys(initialData).length === 0) return;

        // reset form
        setFormData({
            ...initialData,
            active_yn: initialData.active_yn || ''
        });

        // reset role
        setSelectedRole(initialData.userRole);

        // reset departments
        const deptArray = initialData.departmentname
            ? initialData.departmentname.split(',').map(d => d.trim())
            : [];

        setSelectedDepartments(deptArray);
    };

    const handleEdit = (userId, mode) => {
        if (!userId) {
            console.error("userId is undefined");
            return;
        }

        const userToEditIndex = sortedAndFilteredUsers.findIndex(
            user => user.userId === userId
        );

        const actualIndex =
            (userPerPage - 1) * usersItemsPerPage + userToEditIndex;

        if (userToEditIndex !== -1) {
            const selectedUser = sortedAndFilteredUsers[userToEditIndex];

            // ✅ form data
            setFormData({
                ...selectedUser,
                active_yn: selectedUser.active_yn || ''
            });

            // ✅ role
            setSelectedRole(selectedUser.userRole);

            // ✅ NEW: department prefill (IMPORTANT FIX)
            const deptArray = selectedUser.departmentname
                ? selectedUser.departmentname.split(',').map(d => d.trim())
                : [];

            setSelectedDepartments(deptArray);

            // optional (if you still need it)
            // handleHierarchyChange(selectedUser.orgHierarchy);

            setInitialData(selectedUser);
            setEditIndex(actualIndex);
            setMode(mode);
            handleShow(true, mode);
        }
    };

    const requestSort = (key) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key, direction });
    };

    const getSortIcon = (key) => {
        if (sortConfig.key !== key) {
            return <BiSort />;  // Neutral/no sort icon
        }
        return sortConfig.direction === 'ascending'
            ? <BiSortUp />
            : <BiSortDown />;
    };
    
    const renderUsersTable = () => {
        const startIndex = (userPerPage - 1) * usersItemsPerPage;
        const paginatedTableData = sortedAndFilteredUsers.slice(startIndex, startIndex + usersItemsPerPage);

        return paginatedTableData
            .filter((data) => data && data.userId) // Filter out undefined or null data
            .map((data) => (
                <tr
                    key={data.userId}
                    className={`${data.newlyCreated ? 'bg-success text-white' : ''}`}
                    style={{
                        transition: 'background-color 0.3s ease',
                    }}
                >
                    <td style={{ width: '10%' }}>
                        <i
                            className='p-1 bi bi-pencil'
                            onClick={() => handleEdit(data.userId, "edit", false)}
                            title="Edit"
                            style={{ cursor: 'pointer' }}
                        ></i>
                    </td>
                    <td style={{ ...tableCellStyle2(startIndex), textAlign: "left" }}>
                        {data.userId}
                    </td>
                    <td style={{ ...tableCellStyle2(startIndex), textAlign: "left" }}>
                        {data.userName}
                    </td>
                    <td style={{ ...tableCellStyle2(startIndex), textAlign: "left" }}>
                        {data.userRole}
                    </td>
                    <td style={{ ...tableCellStyle2(startIndex), textAlign: "left" }}>
                        {data.departmentname}
                    </td>


                </tr>
            ));
    };


    const handleSearch = (event) => {
        const query = event.target.value.toLowerCase();
        setSearchQuery(query);

        const filtered = users.filter(user => {
            const userId = user.userId?.toString().toLowerCase() || "";
            const userName = user.userName?.toLowerCase() || "";
            const userRole = user.userRole?.toLowerCase() || "";
            const department = user.departmentname?.toLowerCase() || "";

            return (
                userId.includes(query) ||
                userName.includes(query) ||
                userRole.includes(query) ||
                department.includes(query)   // ✅ IMPORTANT FIX
            );
        });

        if (filtered.length === 0) {
            setShowNoRecordsModal(true);
            setSearchQuery('');
            setFilteredUsers(users);
        } else {
            setFilteredUsers(filtered);
        }

        setUsersPerPage(1);
    };

    return (
        <div className={`d-flex flex-column min-vh-100 ${styles.pageFullBackground}`}>
            <Header />
            <Navigation />
            <div className="top-0 px-4 py-2 text-white">
                <div className="d-flex justify-content-between align-items-center flex-wrap">
                    <div>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb mb-1">
                                <li className="breadcrumb-item">
                                    <a onClick={handleDashboard} className={`text-info ${styles.textInfo}`} style={{ textDecoration: 'none' }}>
                                        <i className="bi bi-house me-2" style={{ cursor: "pointer" }}></i>/
                                    </a>
                                </li>
                                <li className={`breadcrumb-item active ${styles.breadcrumbItem}`} aria-current="page">
                                    <i className="bi bi-person-plus me-2"></i>RAF - User - Role Mapping
                                </li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
            <main className="flex-grow-1 container-fluid">
                <div className={styles.mainContainer}>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-lg-6 col-md-12 mx-auto">
                                <div className={`card h-100 ${styles.cardBorder} ${styles.card}`}>
                                    <div className="card-body">

                                        {/* Header + Search Row with single underline */}
                                        <div className={`d-flex justify-content-between align-items-center pb-2 mb-2 ${styles.borderBottom}`}>

                                            {/* Left: Heading */}
                                            <h6 className="mb-0">RAF - User - Role Mapping</h6>

                                            {/* Right: Search Box */}
                                            <div className="d-flex flex-wrap gap-3">
                                                <button
                                                    className="btn btn-sm btn-outline-primary"
                                                    onClick={handleAddRow}
                                                    title="Add New User"
                                                >
                                                    <i className="bi bi-plus" style={{ fontSize: '14px' }}></i>
                                                </button>
                                                <SearchBox searchTerm={searchQuery} handleSearch={handleSearch} />
                                            </div>
                                        </div>
                                        {/* Table */}
                                        {/* {isLoading ? (
                                            <div className="d-flex justify-content-center align-items-center" style={{ height: '200px' }}>
                                                <UploadLoadingIcon />
                                            </div>
                                        ) : ( */}
                                        <div className="table-on-homepage-only mb-3">
                                            <div className={`tableWrapper ${tableStyles.tableWrapper}`}>
                                                <table className={`table table-bordered table-hover text-center customScrollTable ${tableStyles.customScrollTable}`}>
                                                    <thead className="sticky-header">
                                                        {selectedOption !== 'All' && (
                                                            <tr className="rowFilter">
                                                                <td colSpan="6">Applied Filter : {selectedOption}</td>
                                                            </tr>
                                                        )}
                                                        <tr>
                                                            <th>Modify</th>
                                                            <th onClick={() => requestSort('userId')}>
                                                                UserId
                                                                <span style={{ textAlign: 'center', padding: '5px' }}>
                                                                    {getSortIcon('userId')}
                                                                </span>
                                                            </th>

                                                            <th onClick={() => requestSort('userFirstName')}>
                                                                User Name
                                                            </th>
                                                            <th>User Role</th>
                                                            <th>Department</th>

                                                        </tr>
                                                    </thead>
                                                    <tbody>{renderUsersTable()}</tbody>
                                                </table>
                                            </div>
                                        </div>
                                        {/* )} */}


                                        {/* Pagination */}
                                        <div className="d-flex justify-content-end">
                                            <UsersPagination
                                                currentPage={userPerPage}
                                                itemsPerPage={usersItemsPerPage}
                                                totalItems={sortedAndFilteredUsers.length}
                                                onPageChange={setUsersPerPage}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-12">
                                <div className={`card h-100 ${styles.cardBorder} ${styles.card}`}>
                                    <div className="card-body">
                                        <div className="">
                                            <h6 className={`pb-1 mb-2 ${styles.borderBottom}`}>Modify RAF - User - Role Mapping</h6>
                                            <div className={`mx-auto ${formStyles.formWrapper}`}>
                                                {/* {isLoading && (
                                                    <>
                                                        <div style={{
                                                            position: 'absolute',
                                                            top: 0,
                                                            left: 0,
                                                            right: 0,
                                                            bottom: 0,
                                                            backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                                            zIndex: 1040
                                                        }} />
                                                        <div style={{
                                                            position: 'absolute',
                                                            top: '50%',
                                                            left: '50%',
                                                            transform: 'translate(-50%, -50%)',
                                                            zIndex: 1050
                                                        }}>
                                                            <div className="spinner-border text-dark" role="status">
                                                                <span className="visually-hidden">Loading...</span>
                                                            </div>
                                                        </div>
                                                    </>
                                                )} */}
                                                {mode === "edit" ? (
                                                    <form className="form" onSubmit={handleLdapSubmit}>
                                                        <div className="form-group row">
                                                            <div className="col-sm-12">
                                                                <input
                                                                    type="hidden"
                                                                    name="adminId"
                                                                    value={localStorage.getItem('userid')}
                                                                    readOnly
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="form-group row mb-2 d-flex align-items-center">
                                                            <label className="col-sm-4 col-form-label small text-muted">User Id</label>
                                                            <div className="col-sm-7">
                                                                <input
                                                                    type="text"
                                                                    className="form-control form-control-sm"
                                                                    name="userId"
                                                                    value={formData.userId}
                                                                    onChange={handleChange}
                                                                    onFocus={handleFocus}
                                                                    disabled={mode === "edit"}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="form-group row mb-1 d-flex align-items-center">
                                                            <label className="col-sm-4 col-form-label small text-muted">User Name</label>
                                                            <div className="col-sm-7">
                                                                <input
                                                                    type="text"
                                                                    className="form-control form-control-sm"
                                                                    name="userFirstName"
                                                                    value={formData.userName}
                                                                    onChange={handleChange}
                                                                    onFocus={handleFocus}
                                                                    disabled={mode === "edit"}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="form-group row mb-1 d-flex align-items-center">
                                                            <label className="col-sm-4 col-form-label small text-muted">User Role</label>
                                                            <div className="col-sm-7">
                                                                <select
                                                                    className="form-select form-select-sm"
                                                                    name="userRole"
                                                                    value={formData.userRole || ""}
                                                                    onChange={(e) => {
                                                                        const role = e.target.value;
                                                                        setFormData({ ...formData, userRole: role });
                                                                        setSelectedRole(role);

                                                                        // Reset departments if role changes
                                                                        setSelectedDepartments([]);
                                                                    }}
                                                                >
                                                                    <option value="">Select Role</option>
                                                                    {roles.map((role, index) => (
                                                                        <option key={index} value={role}>
                                                                            {role}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                        </div>

                                                        <div className="form-group row mb-1 d-flex align-items-center">
                                                            <label className="col-sm-4 col-form-label small text-muted">RAF Department</label>

                                                            <div className="col-sm-7">
                                                                <div className="dropdown">
                                                                    <button
                                                                        className="btn btn-light btn-sm dropdown-toggle w-100 text-start text-truncate"
                                                                        type="button"
                                                                        data-bs-toggle="dropdown"
                                                                        style={{
                                                                            overflow: "hidden",
                                                                            whiteSpace: "nowrap",
                                                                            textOverflow: "ellipsis"
                                                                        }}
                                                                    >
                                                                        {selectedDepartments.length > 0
                                                                            ? selectedDepartments.join(", ")
                                                                            : "Select Department"}
                                                                    </button>

                                                                    <ul className="dropdown-menu w-100" style={{ maxHeight: "200px", overflowY: "auto" }}>
                                                                        {departments.map((dept, index) => (
                                                                            <li key={index} className="px-2">
                                                                                <div className="form-check">
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        className="form-check-input"
                                                                                        id={`dept-${index}`}
                                                                                        checked={selectedDepartments.includes(dept)}
                                                                                        onChange={(e) => {
                                                                                            const isDeptHead = selectedRole === "Department Head";

                                                                                            if (e.target.checked) {
                                                                                                if (isDeptHead) {
                                                                                                    // single select
                                                                                                    setSelectedDepartments([dept]);
                                                                                                } else {
                                                                                                    // multi select
                                                                                                    setSelectedDepartments([...selectedDepartments, dept]);
                                                                                                }
                                                                                            } else {
                                                                                                setSelectedDepartments(
                                                                                                    selectedDepartments.filter(d => d !== dept)
                                                                                                );
                                                                                            }
                                                                                        }}
                                                                                    />

                                                                                    <label
                                                                                        className="form-check-label"
                                                                                        htmlFor={`dept-${index}`}
                                                                                    >
                                                                                        {dept}
                                                                                    </label>
                                                                                </div>
                                                                            </li>
                                                                        ))}
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </div>


                                                        <div className="form-group row mt-2 ms-1">
                                                            <div className="col-sm-4"></div>
                                                            <div className="col-sm-7 d-flex">
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-sm btn-outline-secondary me-2 flex-grow-1"
                                                                    onClick={handleReset}
                                                                >
                                                                    Reset
                                                                </button>
                                                                <button
                                                                    type="submit"
                                                                    className="btn btn-sm btn-primary flex-grow-1"

                                                                    disabled={disableInputs}
                                                                >
                                                                    Save
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </form>
                                                ) : (
                                                    <div className="text-center py-4">
                                                        <p className="text-muted small">Select a user to modify</p>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {showAllowUploadPopup && (
                                <Modal show onHide={handleCancelUpload} backdrop="static" keyboard={false} style={{ marginTop: '12vh' }}>
                                    <Modal.Header style={{ backgroundColor: '#366872', color: 'white', padding: '0.5rem 1rem' }}>
                                        <Modal.Title style={{ fontSize: '16px' }}>Confirmation</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body style={{ padding: '0.75rem 1rem', fontSize: '14px' }}
                                        /* <sttong>{toTitleCase(editableTableName)}</sttong> Template is already exists. Do you wish to upload data with the same template? */
                                        dangerouslySetInnerHTML={{
                                            __html: modalMessage3.replace(/\n/g, '<br />')
                                        }}>
                                    </Modal.Body>
                                    <Modal.Footer style={{ borderTop: 'none' }}>
                                        <Button variant="secondary" onClick={handleCancelUpload}>No</Button>
                                        <Button variant="primary" onClick={handleForceUpload}>Yes</Button>
                                    </Modal.Footer>
                                </Modal>
                            )}

                            {/* Modal for messages */}
                            <Modal
                                show={!!modalMessage}
                                onHide={handleCloseModal}
                                backdrop="static"
                                keyboard={false}
                                style={{ marginTop: '12vh' }}
                            >
                                <div
                                    className={`alert alert-${messageType === 'success' ? 'success' : messageType === 'warning' ? 'warning' : 'danger'} alert-dismissible fade show`}
                                    role="alert"
                                    style={{ marginBottom: '0' }}
                                >
                                    <div className="d-flex align-items-center">
                                        {messageType === 'success' ? (
                                            <span className="me-2" style={{ color: 'green', fontSize: '14px' }}>✅</span>
                                        ) : messageType === 'warning' ? (
                                            <span className="me-2" style={{ color: '#ffc107', fontSize: '14px' }}>⚠️</span>
                                        ) : (
                                            <span className="me-2" style={{ color: 'red', fontSize: '14px' }}>❌</span>
                                        )}
                                        <p
                                            style={{
                                                display: 'inline',
                                                marginBottom: '0px',
                                                color: messageType === 'success'
                                                    ? 'green'
                                                    : messageType === 'warning'
                                                        ? '#ffc107'
                                                        : 'red'
                                            }}
                                        >
                                            {modalMessage}
                                        </p>
                                    </div>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        onClick={handleCloseLdap}
                                        style={{ width: '15px', height: '15px', fontSize: '8px', position: 'absolute', bottom: '10px', right: '10px' }}
                                    />
                                </div>
                            </Modal>
                        </div>
                    </div>
                </div>
            </main>
            <Footer />
        </div>
    );
};

export default GapsyUserRoleandMapping;
